import { Strategy, } from "./ancillary.js";
export function isMethodDescriptor(input) {
    return Boolean(input.value);
}
export function memoizeMethod(descriptor, propertyKey, strategy, hashFunction, argsCacheBuilder) {
    const originalMethod = descriptor.value;
    switch (originalMethod.length) {
        case 0: {
            switch (strategy) {
                case Strategy.REPLACE: {
                    descriptor.value = function () {
                        const calculated = originalMethod.apply(this);
                        Object.defineProperty(this, propertyKey, {
                            enumerable: descriptor.enumerable,
                            configurable: descriptor.configurable,
                            writable: descriptor.writable,
                            value: function () {
                                return calculated;
                            },
                        });
                    };
                    return;
                }
                case Strategy.WEAKMAP: {
                    const bindingsCache = new WeakMap();
                    descriptor.value = function () {
                        if (bindingsCache.has(this)) {
                            return bindingsCache.get(this);
                        }
                        let calculated = originalMethod.apply(this);
                        bindingsCache.set(this, calculated);
                        return calculated;
                    };
                    break;
                }
            }
            break;
        }
        case 1: {
            switch (strategy) {
                case Strategy.WEAKMAP: {
                    const bindingsCache = new WeakMap();
                    descriptor.value = function (arg) {
                        let argsCache = bindingsCache.get(this);
                        if (!argsCache) {
                            argsCache = argsCacheBuilder();
                            bindingsCache.set(this, argsCache);
                        }
                        if (argsCache.has(arg)) {
                            return argsCache.get(arg);
                        }
                        const memoized = originalMethod.call(this, arg);
                        argsCache.set(arg, memoized);
                        return memoized;
                    };
                    break;
                }
                case Strategy.REPLACE: {
                    descriptor.value = function (arg) {
                        const memoizationContainer = argsCacheBuilder();
                        function replacement(arg) {
                            if (memoizationContainer.has(arg)) {
                                return memoizationContainer.get(arg);
                            }
                            else {
                                const memoized = originalMethod.call(this, arg);
                                memoizationContainer.set(arg, memoized);
                                return memoized;
                            }
                        }
                        Object.defineProperty(this, propertyKey, {
                            configurable: descriptor.configurable,
                            enumerable: descriptor.enumerable,
                            writable: descriptor.writable,
                            value: replacement,
                        });
                        return replacement.call(this, arg);
                    };
                    break;
                }
            }
            break;
        }
        default: {
            switch (strategy) {
                case Strategy.REPLACE: {
                    descriptor.value = function (...args) {
                        const memoizationContainer = argsCacheBuilder();
                        function replacement(...args) {
                            const digest = hashFunction.apply(this, args);
                            if (memoizationContainer.has(digest)) {
                                return memoizationContainer.get(digest);
                            }
                            else {
                                const memoized = originalMethod.apply(this, args);
                                memoizationContainer.set(digest, memoized);
                                return memoized;
                            }
                        }
                        Object.defineProperty(this, propertyKey, {
                            configurable: descriptor.configurable,
                            enumerable: descriptor.enumerable,
                            writable: descriptor.writable,
                            value: replacement,
                        });
                        return replacement.apply(this, args);
                    };
                    break;
                }
                case Strategy.WEAKMAP: {
                    const bindingsCache = new WeakMap();
                    descriptor.value = function replacement(...args) {
                        let argsCache = bindingsCache.get(this);
                        const digest = hashFunction.apply(this, args);
                        if (argsCache?.has(digest)) {
                            return argsCache.get(digest);
                        }
                        if (!argsCache) {
                            argsCache = argsCacheBuilder();
                            bindingsCache.set(this, argsCache);
                        }
                        const memoized = originalMethod.apply(this, args);
                        argsCache.set(digest, memoized);
                        return memoized;
                    };
                }
            }
        }
    }
}
